import NativeSelect from 'components/native-select/NativeSelect';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import Component, { forceArray } from 'navigation/component/Component';
export default class ReturnsItemRow extends Component {
    _choice = null;
    _reason = null;
    id;
    get choice() {
        return this._choice;
    }
    get reason() {
        return this._reason;
    }
    set choice(value) {
        const previous = this._choice;
        this.reset();
        this._choice = value;
        if (value) {
            this.el.setAttribute('data-choice', value);
            this.updateRequirements();
        }
        else {
            this.el.removeAttribute('data-choice');
        }
        if (previous !== value)
            this.emit('update:choice', value);
    }
    set reason(value) {
        const previous = this._reason;
        this._reason = value;
        if (previous !== value)
            this.emit('update:reason', value);
        if (value)
            this.el.setAttribute('data-reason', value);
        else
            this.el.removeAttribute('data-reason');
    }
    getModulesMap() {
        return {
            reasons: ['.native-select', NativeSelect]
        };
    }
    initialized() {
        super.initialized();
        this.id = this.el.dataset.id;
        // add choice change call to detect choices if provided by session
        this.refs.toggleChoices?.forEach((el) => {
            if (el.checked) {
                this._choice = el.value;
                this.el.setAttribute('data-choice', el.value);
                this.updateRequirements();
            }
        });
        this.modules.reasons?.forEach(select => {
            // this.this.handleReasonChange({ c })
            if (select.refs?.select.value) {
                this._reason = select.refs.select.value;
                this.el.setAttribute('data-reason', select.refs.select.value);
            }
        });
    }
    bindEvents(add) {
        const method = bindMethod(add);
        const emitterMethod = bindEmitterMethod(add);
        this.refs.toggleChoices?.forEach((el) => {
            el[method]('change', this.handleChoiceChange);
        });
        this.modules.reasons?.forEach(select => {
            select[emitterMethod]('change', this.handleReasonChange);
        });
        window[method]('returns:update-size', this.handleSizeUpdate);
        window[method]('returns:update-color', this.handleColorUpdate);
    }
    handleChoiceChange = (e) => {
        const target = e.currentTarget;
        const other = this.refs.toggleChoices.find((el) => el !== target);
        if (target.checked) {
            this.choice = target.value;
            if (other)
                other.checked = false;
        }
        else {
            this.choice = null;
        }
        if (this.choice === null || this.choice === 'return') {
            forceArray(this.refs.sizeInput).forEach((input) => {
                input.removeAttribute('data-required');
            });
        }
        forceArray(this.refs.sizeInput).forEach(input => {
            input.parentElement?.parentElement?.classList.remove('error');
        });
        this.emit('update:choice', this.choice);
    };
    handleReasonChange = (value) => {
        forceArray(this.refs.sizeInput).forEach((input) => {
            if (this.choice === 'exchange')
                input.setAttribute('data-required', 'true');
            else
                input.removeAttribute('data-required');
        });
        forceArray(this.refs.colorInput || []).forEach((input) => {
            if (this.choice === 'exchange')
                input.setAttribute('data-required', 'true');
            else
                input.removeAttribute('data-required');
        });
        this.reason = value?.value || null;
    };
    updateRequirements = () => {
        if (this.choice === 'exchange')
            this.modules.reasons[0].refs.select.setAttribute('data-required', 'true');
        if (this.choice === 'return')
            this.modules.reasons[1].refs.select.setAttribute('data-required', 'true');
        forceArray(this.refs.sizeInput).forEach((input) => {
            if (this.choice === 'exchange')
                input.setAttribute('data-required', 'true');
            else
                input.removeAttribute('data-required');
        });
        this.emit('revalidate');
    };
    reset() {
        this.reason = null;
        this.modules.reasons.forEach(select => {
            select.reset();
        });
        this.refs.sizeInput.forEach((input) => {
            if (!(input.dataset.os))
                input.value = '';
        });
        this.refs.sizeLabel.forEach((label) => {
            if (label.dataset.os === undefined)
                label.innerHTML = '';
        });
        this.emit('revaliate');
    }
    handleSizeUpdate = (e) => {
        const { id, sizeId, sizeName } = e.detail;
        if (id === this.id) {
            this.refs.sizeLabel[0].textContent = sizeName;
            this.refs.sizeInput[0].value = sizeId;
            this.refs.sizeInput[0].dispatchEvent(new Event('change'));
            let href = this.refs.toggleSizeSelector[0].getAttribute('data-panel');
            href = href.replace(/current=\d+/, `current=${sizeId}`);
            this.refs.toggleSizeSelector[0].setAttribute('data-panel', href);
            this.emit('update:size');
        }
    };
    handleColorUpdate = (e) => {
        const { id, colorId, code, articleId, pattern } = e.detail;
        if (id === this.id) {
            this.refs.colorPattern.innerHTML = pattern;
            this.refs.colorSwatch.style.backgroundColor = code;
            this.refs.colorInput[0].value = colorId;
            this.refs.colorInput[0].dispatchEvent(new Event('change'));
            let href = this.refs.toggleColorSelector[0].getAttribute('data-panel');
            href = href.replace(this.el.dataset.recordId, articleId);
            this.refs.toggleColorSelector[0].setAttribute('data-panel', href);
            this.emit('update:color');
        }
    };
}
